import React, {useState} from 'react';
import {Player} from './types';
import {uid} from './random';

interface Props {
    players: Player[];
    setPlayers: (players: Player[]) => void;
    minPlayers: number;
}

const PlayerSetup: React.FC<Props> = ({players, setPlayers, minPlayers}) => {
    const [newName, setNewName] = useState('');

    const addPlayer = () => {
        const name = newName.trim();
        if (!name) return;
        setPlayers([...players, {id: uid(), name}]);
        setNewName('');
    };

    const removePlayer = (id: string) => {
        setPlayers(players.filter(p => p.id !== id));
    };

    return (
        <div className="GmCard">
            <h3 className="GmCard-title">Игроки ({players.length})</h3>

            <div className="GmList">
                {players.map((player, index) => (
                    <div className="GmListItem" key={player.id}>
                        <span className="GmListItem-index">{index + 1}</span>
                        <span className="GmListItem-name">{player.name}</span>
                        <button className="GmIconBtn" onClick={() => removePlayer(player.id)} aria-label="Удалить">✕</button>
                    </div>
                ))}
                {players.length === 0 && (
                    <p className="GmHint">Добавьте хотя бы {minPlayers} игроков</p>
                )}
            </div>

            <div className="GmInputRow">
                <input
                    className="GmInput"
                    placeholder="Имя игрока"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') addPlayer();
                    }}
                />
                <button className="GmBtn" onClick={addPlayer}>Добавить</button>
            </div>

            {players.length > 0 && players.length < minPlayers && (
                <p className="GmHint GmHint--warn">Нужно минимум {minPlayers} игрока(ов)</p>
            )}
        </div>
    );
};

export default PlayerSetup;
